// extracted by mini-css-extract-plugin
module.exports = {"container":"frequency-list_container__38NU0","card":"frequency-list_card__bUxxC"};